import { ReducerFunctions } from "../../utils";
import {AllTemplates, UpdateTemplates, DefaultTemplate,OldTemplate} from "./templates";

export const  all_templates = ReducerFunctions(AllTemplates, {});
export const update_templates = ReducerFunctions(UpdateTemplates, {});
export const default_template = ReducerFunctions(DefaultTemplate, {});
export const old_template = ReducerFunctions(OldTemplate, {});